<template>
  <div class="gwh_top">
    <!-- <img class="xi" style="width:100%;cursor: pointer;" src="/statics/image/index/xi.jpg" alt @click="toxi" /> -->
    <div v-if="adlist&&adlist[10]&&adlist[10].ad">
      <img
        class="xi"
        v-for="(item,index) in adlist[10].ad"
        :key="index"
        :src="adddom(item.ad_thumb)"
        alt
        @click="torightAd(item.ad_url)"
      />
    </div>
    <div class="top">
      <img class="pic" src="/statics/image/index/top_banner.png" alt />
      <!-- 搜索 -->
      <div class="center">
        <div class="search">
          <el-input v-model="souvalue" placeholder="请输入内容" @change="toSeach">
            <el-button slot="append" icon="el-icon-search" @click="toSeach"></el-button>
            <!-- <template slot="append">
               <img src="/statics/image/index/top_search.png" alt />
            </template>-->
          </el-input>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="inner">
        <!--  -->
        <span class="navzi" @click="toPage(-1,-1,0)" :class="nowindex == -1?'act':''">
          <span>首页</span>
        </span>
        <!-- <span @click="toPath('/xqgk',{})">新区概况</span>
        <span @click="toPath('/xqNews',{})">新区要闻</span>
        <span @click="toPath('/zsyz',{})">招商引资</span>
        <span @click="toPath('/xzsp',{})">行政审批</span>
        <span @click="toPath('/zhengwu',{})">政务公开</span>
        <span @click="toPath('/zwfw',{})">政务服务</span>
        <span @click="toPath('/ztzl',{})">专题专栏</span>
        <span @click="toPath('/interaction',{})">互动交流</span>
        <span @click="toPath('/leaderInfo',{})">领导信息</span>-->
        <!-- :class="nowindex == index?'act':''" -->
        <span
          class="navzi"
          v-for="(item,index) in catelist"
          :key="index"
          :class="nowindex == index?'act':''"
          :style="!item.display?'display:none':''"
        >
          <a
            :href="item.url"
            v-if="item.display&&item.link_flag==1"
            target="_blank"
          >{{item.title?item.title:''}}</a>
          <span
            v-if="item.display&&item.link_flag==0"
            @click="toPage(item.id,index)"
          >{{item.title?item.title:''}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      adlist: [],
      souvalue: "",
      catelist: [],
      nowId: "",
      nowindex: ""
    };
  },
  created() {
    // if (localStorage.getItem("topvalue")) {
    //   localStorage.removeItem("topvalue");
    // }
    // if (localStorage.getItem("tabvalue")) {
    //   localStorage.removeItem("tabvalue");
    // }

    if (localStorage.getItem("topvalue")) {
      this.souvalue = localStorage.getItem("topvalue");
      setTimeout(function() {
        localStorage.removeItem("topvalue");
      }, 1000);
    }
    if (this.$route.name == "home") {
      this.nowId = -1;
      this.nowindex = -1;
    } else if (this.$route.name == "wz_map") {
      this.nowId = -2;
      this.nowindex = -2;
    } else {
      this.nowindex = this.$route.query.index;
    }
    this.getHome();
    this.getNav();
  },
  computed: {
    souvalueChange: {
      get: function() {
        return this.$store.state.user.souvalueChange;
      },
      set: function() {}
    }
  },
  methods: {
    // toxi() {
    //   window.open(
    //     "http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm",
    //     "_blank"
    //   );
    // },
    // 首页接口
    getHome() {
      var that = this;
      that.$api.index.index({}).then(function(res) {
        if (res.code == 200) {
          that.adlist = res.result.adlist;
        }
      });
    },
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    torightAd(url) {
      window.open(url);
    },
    toPath(url, obj) {
      if (this.$route.fullPath == url) {
        return;
      }
      if (this.$route.path == url) {
        this.$router.push({
          path: url,
          query: obj
        });
        return;
      }
      this.$router.push({
        path: url,
        query: obj
      });
    },
    toPage(id, index) {
      console.log("toPage",index);
      this.souvalue = "";
      localStorage.removeItem("topvalue");
      localStorage.removeItem("tabvalue");
      this.topvalue = "";
      this.nowId = id;
      this.nowindex = index;
      // console.log("top", this.nowindex);
      if (id == 5463) {
        this.toPath("/leaderInfo", { index: index });
      } else if (id == 36) {
        this.toPath("/leaderInfo", { index: index });
      } else if (id == 5473) {
        this.toPath("/interaction", { index: index });
      } else if (id == 29) {
        this.toPath("/ztzl", { index: index });
      } else if (id == -1) {
        this.toPath("/", {});
      } else {
        this.toPath("/xqNews", { id: id, index: index });
      }
    },
    getNav() {
      var that = this;
      that.$api.index.catelist({'type':'1'}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;
        }
      });
    },
    toSeach() {
      // console.log("topsss");
      // console.log("点击搜索",this.souvalue,this.$route.fullPath);
      // console.log(this.$route.name);
      if (
        this.$route.name == "xqNews" ||
        this.$route.name == "leaderInfo" ||
        this.$route.name == "showNews"
      ) {
        if (this.souvalue && this.souvalue != "") {
          localStorage.setItem("topvalue", this.souvalue);
          window.location.reload();
        } else {
          this.$message({
            message: "搜索内容不能为空！",
            type: "warning"
          });
        }
      } else {
        if (this.souvalue && this.souvalue != "") {
          localStorage.setItem("topvalue", this.souvalue);
          // this.souvalue = localStorage.getItem("topvalue");
          if (this.$route.path != "/sea_result") {
            this.$router.push({
              path: "/sea_result"
            });
          } else {
            window.location.reload();
          }
        } else {
          this.$message({
            message: "搜索内容不能为空！",
            type: "warning"
          });
        }
      }
    }
  },
  mounted() {
    // console.log("topmmm",this.souvalue);
    //   setTimeout(function(){
    //   this.$store.commit("setSouvalue", { val: false });
    //   }.bind(this),2000)
    let that = this;
    // console.log(that.nowindex, $(".gwh_top .nav span")[that.nowindex * 1 + 1]);
    // setTimeout(function() {
    //   $($(".gwh_top .nav span")[that.nowindex * 1 + 1]).addClass("act");
    // }, 1000);
    // console.log(this.$route.query,$('.gwh_top .nav span')[0])
    // setTimeout(function(){
    //   if(that.$route.query.id == -1){
    //     $($('.gwh_top .nav span')[0]).addClass('act')
    //   }
    //   if(that.$route.query.id == 11){
    //     $($('.gwh_top .nav span')[1]).addClass('act')
    //   }
    //   if(that.$route.query.id == 12){
    //     $($('.gwh_top .nav span')[2]).addClass('act')
    //   }
    //   if(that.$route.query.id == 13){
    //     $($('.gwh_top .nav span')[3]).addClass('act')
    //   }
    //   if(that.$route.query.id == 14){
    //     $($('.gwh_top .nav span')[4]).addClass('act')
    //   }
    //   if(that.$route.query.id == 29){
    //     $($('.gwh_top .nav span')[5]).addClass('act')
    //   }
    //   if(that.$route.query.id == 5463){
    //     $($('.gwh_top .nav span')[6]).addClass('act')
    //   }
    // },300)
  },
  watch: {
    souvalueChange: function(val, oldval) {
      if (val == false) {
        this.souvalue = "";
        this.$store.commit("setSouvalue", { val: true });
      }
    },
    $route(to, from) {
      if (from.name == "showNews" && to.name == "xqNews") {
        this.souvalue = "";
        if (localStorage.getItem("topvalue")) {
          localStorage.removeItem("topvalue");
        }
      }
      // this.souvalue = "";
      // console.log("to", to.name);
      // console.log(this.$route.name);
      // console.log("from", from.name);
      // if (to.name == "xqNews" && from.name == "ztzl") {
      //   this.nowindex = this.$route.query.index;
      //   // this.getNav();
      // }
      // if (to.name == "wz_map"||to.name == "sea_result") {
      if (this.$route.name == "home") {
        this.nowId = -1;
        this.nowindex = -1;
      } else if (this.$route.name == "wz_map") {
        this.nowId = -2;
        this.nowindex = -2;
      } else if (this.$route.name == "sea_result") {
        this.nowId = -3;
        this.nowindex = -3;
      } else {
        this.nowindex = this.$route.query.index;
      }
      this.getNav();
      // }
    }
  }
};
</script>

<style>
</style>